/* eslint-disable import/prefer-default-export */
export const encode: (data: object) => string = (data) =>
  Object.entries(data)
    .filter(([, value]) => !!value)
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join('&');
